export const getExtensionType = (message) => {
    const regex = /(?:\.([^.]+))?$/;
    const match = message?.match(regex);
    let ext = match ? match[1] : "";
    return ext;
};
export const formatTime = (date) => {
  const messageDateStr = date?.replace(' at', '');
  const currentTime = new Date(messageDateStr);
  let hours = currentTime.getHours();
  const minutes = currentTime.getMinutes().toString().padStart(2, '0');
  const seconds = currentTime.getSeconds().toString().padStart(2, '0');
  
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const formattedTime = `${hours}:${minutes} ${ampm}`;
  
  return formattedTime;
}
export const formatDate = (date) => {
  if (!date) return '';

  const messageDateStr = date.replace(' at', '');
  const messageDate = new Date(messageDateStr);
  const now = new Date();

  // Format time part
  let hours = messageDate.getHours();
  const minutes = messageDate.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const formattedTime = `${hours}:${minutes} ${ampm}`;

  // Format date part
  const isToday = messageDate.toDateString() === now.toDateString();

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday = messageDate.toDateString() === yesterday.toDateString();

  if (isToday) {
    return `Today`;
  } else if (isYesterday) {
    return `Yesterday`;
  } else {
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    const formattedDate = messageDate.toLocaleDateString(undefined, options);
    return `${formattedDate}`;
  }
};

//---------------api call date formate---------------//
export const getFormattedDateTime = (data = null) => {
    const date = new Date(data || Date.now());
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-US", options);
  };

  export const parseDate = (dateString) => {
    return new Date(dateString?.replace(' at ', ' ')?.replace(/,/g, ''));
}

// Function to get the current date in the same format
export const getCurrentToISOStringDate = () => {
  const now = new Date();
  return now.toISOString().replace('Z', '').slice(0, -1);
};

// get file function
export const getDisplayFileName = (url) => {
    try {
      const fullFilename = url?.split("/").pop() || "file";
      const parts = fullFilename.split(".");
      const nameWithId = parts.slice(0, -1).join(".");
      const extension = parts.pop();

      const nameParts = nameWithId.split("_");
      const originalName = nameParts.slice(0, -1).join("_");

      return originalName ? `${originalName}.${extension}` : fullFilename;
    } catch {
      return url?.split("/").pop() || "file";
    }
  };

// Function to set word limit on massage and show ......//
export const truncateWords = (text, maxWords) => {
  if (typeof text !== 'string') return '';
  
  const words = text.trim().split(/\s+/);
  
  if (words.length <= maxWords) return text;
  
  return words.slice(0, maxWords).join(' ') + ' ......';
};
export const audioformatTime = (time) => {
  if (!time && time !== 0) return "00:00";
  const minutes = Math.floor(time / 60).toString().padStart(2, '0');
  const seconds = Math.floor(time % 60).toString().padStart(2, '0');
  return `${minutes}:${seconds}`;
};
export const recordingformatTime = (seconds) => {
  const mins = String(Math.floor(seconds / 60)).padStart(2, '0');
  const secs = String(seconds % 60).padStart(2, '0');
  return `${mins}:${secs}`;
};